var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "basic-modal",
      attrs: {
        id: _vm.id,
        title: _vm.title,
        "close-title": _vm.closeTitle || _vm.$t("common.cancel"),
        "ok-title": _vm.okTitle || _vm.$t("common.confirm")
      },
      on: { ok: _vm.ok, cancel: _vm.cancel }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8ffd462", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8ffd462","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicModal.vue
// module id = eYCq
// module chunks = 1